/**
 * W2 D3 —— 分段卡的画幅口径(纯函数,面板只做渲染)。
 *
 * 长图的区块**同宽不同高**(全部 750 宽:图块 3:4/1:1,文案/数据块是 100~300 高的横条)。
 * 老版分段卡恒 `aspect-[4/3] object-cover`,横条被居中裁掉两端 —— 实测 8 块里 4 块看不出
 * 是什么(「痛点大字」只剩 `乳打底,奶香`、「规格参数」「好评背书」整张空白)。
 * 而这个面板的唯一用途就是「找到我想重出的那一块」,认不出来就等于没有。
 *
 * 现在按真实画幅贴、**从不裁剪**:高 = 卡宽 × h/w,与它在整图里的相对比例一致。
 */
import type { PosterAssetDto } from "../../api/posterService";
import { STYLE_META } from "./blocks";

/** 横条判据:宽高比 ≥ 此值的块占两列。2.5 = 750×300,正好把最「厚」的数据块也算进来。 */
export const WIDE_BAND_ASPECT = 2.5;

/** 画面高度区间(px):下限保证可点,上限防 3:4 图块把一行撑得过高(超限走 contain 留边不裁)。 */
export const SEG_MIN_H = 40;
export const SEG_MAX_H = 240;

/**
 * 分段画面的宽高比。真实像素优先(用户拿到的就是它);失败块没有像素 —— 按样式原语给个
 * 合理默认(图块 3:4,文/数据块横条 3:1),这样失败卡的形状也和它在整图里的位置对得上。
 */
export function segmentAspect(
  s: Pick<PosterAssetDto, "actualWidth" | "actualHeight" | "styleTag">
): number {
  if (s.actualWidth && s.actualHeight && s.actualWidth > 0 && s.actualHeight > 0) {
    return s.actualWidth / s.actualHeight;
  }
  const primitive = s.styleTag ? STYLE_META[s.styleTag]?.primitive : undefined;
  return primitive === "image" ? 3 / 4 : 3;
}
